export default __webpack_public_path__ + "static/media/brown-5.7ae2697e.png";